<script>
import store_delete from "@/mixins/store-delete";
import { mapGetters } from "vuex";
import _merge from "lodash/merge";
import _isEqual from "lodash/isEqual";
import _orderBy from "lodash/orderBy";
import _filter from "lodash/filter";
import _some from "lodash/some";
import storeForm from "@/modal/store-form";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

const selectOptions = {
  sortBy: {
    // ID: "ID",
    name: "Name",
    brand: "Brand",
    zone: "Zone",
    program: "Program",
    address: "Address",
  },
  orderBy: {
    DESC: "DESC",
    ASC: "ASC",
  },
};

const defaultSort = {
  brand: "",
  zone: "",
  program: "",
};

const defaultOrder = {
  sortBy: "name",
  orderBy: "ASC",
};

const defaultQuery = _merge({}, defaultSort, defaultOrder);

export default {
  name: "stores",

  mixins: [store_delete],

  components: {
    simplebar,
  },

  data() {
    return {
      selectOptions,
      loading: false,
      showFilters: true,
      query: _merge({}, defaultQuery, this.$route.query),
      search: "",
      isStoreFormActive: false,
    };
  },

  computed: {
    ...mapGetters("stores", {
      entriesRaw: "entries",
    }),
    entriesFiltered() {
      let entriesFiltered = _orderBy(
        this.entriesRaw,
        this.queryInComp.sortBy,
        this.queryInComp.orderBy.toLowerCase(),
      );
      entriesFiltered = _filter(entriesFiltered, this.computedFilters);
      let input = this.search.toLowerCase();
      entriesFiltered = _filter(entriesFiltered, (entry) => {
        return _some(entry, (value, key) => {
          value = String(value).toLowerCase();
          if (["latitude", "longitude"].includes(key)) {
            return false;
          } else {
            return value.includes(input);
          }
        });
      });
      return entriesFiltered;
    },
    queryInRoute() {
      let queryInRoute = _merge({}, defaultQuery, this.$route.query);
      for (const key in queryInRoute) {
        if (
          {}.hasOwnProperty.call(queryInRoute, key) &&
          !queryInRoute[key].length
        ) {
          delete queryInRoute[key];
        }
      }
      return queryInRoute;
    },
    queryInComp() {
      let queryInComp = _merge({}, this.query);
      for (const key in queryInComp) {
        if (
          {}.hasOwnProperty.call(queryInComp, key) &&
          !queryInComp[key].length
        ) {
          delete queryInComp[key];
        }
      }
      return queryInComp;
    },
    computedFilters() {
      let computedFilters = _merge({}, this.queryInComp);
      let names = Object.getOwnPropertyNames(defaultSort);
      for (const key in computedFilters) {
        if (
          {}.hasOwnProperty.call(computedFilters, key) &&
          !names.includes(key)
        ) {
          delete computedFilters[key];
        }
      }
      return computedFilters;
    },
    hasFilters() {
      for (var key in this.computedFilters) {
        if ({}.hasOwnProperty.call(this.computedFilters, key)) return true;
      }
      return false;
    },
  },

  methods: {
    sortAndOrder(value) {
      if (this.query.sortBy == value) {
        this.query.orderBy = this.query.orderBy == "ASC" ? "DESC" : "ASC";
      } else {
        this.query.sortBy = value;
      }
    },

    removeFilter(tax) {
      if (tax && {}.hasOwnProperty.call(this.query, tax)) this.query[tax] = "";
    },

    pushQuery() {
      this.$router.push({ query: this.queryInComp });
    },

    openModal(store) {
      let options = {
        parent: this,
        component: storeForm,
        hasModalCard: true,
      };
      if (store && {}.hasOwnProperty.call(store, "ID")) {
        options.props = {
          propID: store.ID,
        };
      }
      this.$buefy.modal.open(options);
    },
  },

  watch: {
    query: {
      handler: function () {
        this.pushQuery();
      },
      deep: true,
    },
    $route() {
      if (!_isEqual(this.queryInComp, this.queryInRoute)) {
        let newQuery = _merge({}, defaultQuery, this.queryInRoute);
        this.query = newQuery;
      }
    },
  },
};
</script>

<template>
  <div class="view" id="storesFinder">
    <div class="view__head">
      <div class="row">
        <div class="rowColumn">
          <h2 class="bar__title">Stores</h2>
        </div>
        <div class="rowColumn bar__options">
          <!-- <b-button class="is-small" @click="showFilters = !showFilters">
            <b-icon icon="filter" size="is-small"></b-icon>
          </b-button> -->
          <b-button class="is-primary is-rounded" @click="openModal()">
            <b-icon icon="plus" size="is-small"></b-icon> <span>Add new</span>
          </b-button>
        </div>
      </div>
    </div>

    <app-loading v-if="loading" :grow="true" />

    <div
      v-if="entriesFiltered"
      class="view__body"
      :class="{ loading }"
      v-show="!loading"
    >
      <!-- <div class="feed__tools">
        <div class="tool--search">
          <b-field>
            <b-input v-model="search" icon="search" expanded />
          </b-field>
        </div>
      </div> -->
      <!-- <form class="feed__tools" v-show="showFilters">
        <div class="container">
          <div class="options">
            <div class="option">
              <h3>Sort by</h3>
              <div class="field">
                <label for="sortBy">Pick one</label>
                <select id="sortBy" name="sortBy" v-model="query.sortBy">
                  <option
                    v-for="(option, key) in selectOptions.sortBy"
                    :value="key"
                    :key="key"
                    >{{ option }}</option
                  >
                </select>
              </div>
            </div>
            <div class="option">
              <h3>Order</h3>
              <label for="orderBy">Pick one</label>
              <select id="orderBy" name="orderBy" v-model="query.orderBy">
                <option
                  v-for="(option, key) in selectOptions.orderBy"
                  :value="key"
                  :key="key"
                  >{{ option }}</option
                >
              </select>
            </div>
            <div class="option">
              <h3>Seach</h3>
              <b-input v-model="search" />
            </div>
          </div>
        </div>
      </form> -->
      <div v-if="hasFilters" class="feed__filters">
        <b-field grouped group-multiline>
          <div
            class="control"
            v-for="(term, tax) in computedFilters"
            :key="tax"
          >
            <div
              class="field is-grouped-multiline is-grouped"
              @click="removeFilter(tax)"
            >
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">
                    <span>{{ tax | formatSlug }}</span>
                  </span>
                  <span class="tag is-info">
                    <span>{{ term | formatSlug }}</span>
                    <span class="delete is-small"></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </b-field>
      </div>
      <div class="feed__sorting columnsWrap">
        <div class="column--details">
          <div
            v-for="(label, name) in selectOptions.sortBy"
            :key="name"
            class="th heading sorter spot"
            :class="[{ active: query.sortBy == name }, 'spot--' + name]"
            @click="sortAndOrder(name)"
          >
            <span>{{ label }}</span>
            <b-icon
              :icon="query.orderBy == 'DESC' ? 'arrow-down' : 'arrow-up'"
              size="is-small"
            ></b-icon>
          </div>
        </div>
        <div class="column--actions"></div>
      </div>
      <simplebar class="feed__entries" data-simplebar-auto-hide="true">
        <div
          v-for="store in entriesFiltered"
          :key="store.ID"
          class="entry store columnsWrap"
        >
          <div class="hitbox" @click.prevent="openModal(store)"></div>
          <div class="column--details" @click.prevent="openModal(store)">
            <!-- <div class="td spot spot--ID">{{ store.ID }}</div> -->
            <div class="td spot spot--name">{{ store.name }}</div>
            <div class="td spot spot--brand">
              <a
                v-if="query.brand != store.brand"
                @click.stop.prevent="query.brand = store.brand"
              >
                {{ store.brand | formatSlug }}
              </a>
              <span v-else>{{ store.brand | formatSlug }}</span>
            </div>
            <div class="td spot spot--zone">
              <a
                v-if="query.zone != store.zone"
                @click.stop.prevent="query.zone = store.zone"
              >
                {{ store.zone | formatSlug }}
              </a>
              <span v-else>{{ store.zone | formatSlug }}</span>
            </div>
            <div class="td spot spot--program">
              <template v-if="store.program.length">
                <a
                  v-if="query.program != store.program"
                  @click.stop.prevent="query.program = store.program"
                >
                  {{ store.program | formatSlug }}
                </a>
                <span v-else>{{ store.program | formatSlug }}</span>
              </template>
              <template v-else>
                <span class="spot--empty">N/A</span>
              </template>
            </div>
            <div class="td spot spot--address">{{ store.address }}</div>
          </div>
          <div class="column--actions">
            <!-- <b-button
              icon-left="pen"
              class="button is-small is-info"
              @click.stop.prevent="openModal(store)"
            ></b-button>
            <b-button
              icon-left="trash"
              class="button is-small is-danger"
              @click.stop.prevent="deletePrompt(store.ID)"
            ></b-button> -->
            <b-dropdown aria-role="list" position="is-bottom-left">
              <span class="trigger" slot="trigger" role="button">
                <i
                  class="ibranchfont ibranchfont-ellipsis-h-regular is-size-5"
                ></i>
              </span>
              <b-dropdown-item aria-role="listitem" @click="openModal(store)"
                >Edit</b-dropdown-item
              >
              <b-dropdown-item
                aria-role="listitem"
                @click="deletePrompt(store.ID)"
                >Delete</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </simplebar>
      <div class="feed__showing">
        Showing {{ entriesFiltered.length }} of {{ entriesRaw.length }} stores
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media only screen {
  .title,
  .subtitle {
    margin: 0;
  }
  .view__body.loading {
    opacity: 0.5;
  }
  .view__body {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .feed__tools,
  .feed__filters,
  .feed__sorting,
  .feed__entries {
    border-bottom: 1px solid #f1f2f9;
  }
  .feed__tools,
  .feed__filters {
    padding: 0.5rem 1rem;
  }
  .feed__filters {
    display: flex;
    align-items: center;
    .title {
      padding-right: 0.5rem;
    }
  }
  .feed__tools {
    input[type="submit"] {
      display: none;
    }
    .options {
      width: 100%;
    }
    .option--amount .fields,
    .option--term .fields {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 1rem;
    }
  }
  .feed__entries {
    height: 100%;
    border-top: none;
    flex: 1 1 auto;
    overflow: auto;
    // scroll-behavior: smooth;
    // will-change: scroll;
    // -webkit-overflow-scrolling: touch;
  }
  .columnsWrap {
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 1rem;
    .column--details,
    .column--actions {
      position: relative;
    }
    .column--actions {
      flex: 2.25rem 0 0;
      display: flex;
      align-items: center;
      .trigger {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 0.25rem;
        // background-color: #fff;
      }
    }
  }
  .store {
    cursor: pointer;
    border-bottom: 1px solid #f2f2f2;
    .hitbox {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 0.25rem;
    }
    &:hover {
      .hitbox {
        background-color: rgba(255, 255, 255, 1);
      }
      .trigger {
        border: 1px solid #ccc;
        &:hover {
          border-color: $primary;
          color: $primary;
        }
      }
    }
    .column--details {
      min-height: 4rem;
    }
  }
  .feed__showing {
    font-size: 0.6875rem;
    text-align: center;
    padding: 1rem;
    opacity: 0.75;
  }
  .column--details {
    display: grid;
    width: 100%;
    align-items: center;
    grid-template-columns:
      minmax(5rem, 10fr)
      minmax(4.5rem, 7fr)
      minmax(3rem, 6fr);
  }
  .th,
  .td {
    padding: 0.5rem 1rem 0.5rem 0;
  }
  .th {
    font-size: 0.625rem;
    font-weight: 500;
    margin: 0;
    color: rgba(0, 0, 0, 0.54);
    padding-right: 0;
    .icon {
      font-size: 0.5rem;
    }
  }
  .sorter {
    cursor: pointer;
  }
  .sorter.active,
  .sorter:hover {
    color: #000;
    font-weight: 800;
  }
  .sorter:not(.active):not(:hover) .icon {
    opacity: 0;
  }
  .td {
    font-size: 0.6875rem;
    font-weight: 500;
  }
  .spot--program,
  .spot--address {
    display: none;
  }
  .spot--empty {
    opacity: 0.35;
  }
}
@media only screen and (min-width: 40em) {
  .td {
    font-size: 0.75rem;
  }
  .spot--program {
    display: block;
  }
  .column--details {
    grid-template-columns:
      minmax(5rem, 10fr)
      minmax(4.5rem, 6fr)
      minmax(3rem, 4fr)
      minmax(3rem, 8fr);
  }
  .feed__tools .options {
    display: grid;
    grid-template-columns: 20% 1fr 1fr 20%;
    grid-column-gap: 1rem;
  }
}
@media only screen and (min-width: 53.75em) {
  .spot--address {
    display: block;
  }
  .column--details {
    display: grid;
    grid-template-columns:
      minmax(8rem, 11fr)
      minmax(5rem, 7fr)
      minmax(4rem, 6fr)
      minmax(6rem, 9fr)
      16fr;
  }
}
@media only screen and (max-width: 29.9375em) {
  .th .icon {
    display: none;
  }
}
</style>
